module.exports = __webpack_public_path__ + "img/img2.a6d211fb.png";